import { motion, useScroll, useTransform } from "framer-motion";
import { EASE, maskReveal, rise } from "@/lib/motion";

export const ProfileHeader = ({ profile }) => {
  const { scrollY } = useScroll();
  const photoY = useTransform(scrollY, [0, 240], [0, 28]);
  const photoScale = useTransform(scrollY, [0, 240], [1, 0.92]);

  return (
    <header className="flex flex-col items-center text-center" data-testid="profile-header">
      <motion.div
        style={{ y: photoY, scale: photoScale }}
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: EASE }}
        className="rounded-full p-[3px] bg-white card-shadow"
      >
        <img
          data-testid="profile-photo"
          src={profile.photo_url}
          srcSet={profile.photo_url.endsWith(".webp") ? `${profile.photo_url} 1x, ${profile.photo_url.replace(".webp", "@2x.webp")} 2x` : undefined}
          alt={profile.name}
          width="96"
          height="96"
          fetchpriority="high"
          decoding="async"
          className="block w-[96px] h-[96px] sm:w-[112px] sm:h-[112px] rounded-full object-cover bg-[#EAEAEA]"
        />
      </motion.div>

      <div className="mt-4 overflow-hidden">
        <motion.h1
          variants={maskReveal}
          data-testid="profile-name"
          className="text-[22px] sm:text-2xl font-semibold leading-tight tracking-[-0.01em] text-[#111]"
        >
          {profile.name}
        </motion.h1>
      </div>

      <motion.p
        variants={rise}
        data-testid="profile-bio"
        className="mt-1.5 max-w-[300px] text-sm text-[#666] truncate px-2"
        title={profile.bio}
      >
        {profile.bio}
      </motion.p>
    </header>
  );
};
